import React from 'react';
import { FiGithub, FiLinkedin, FiTwitter, FiMail } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-gray-50 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-6 md:mb-0">
            <h3 className="text-xl font-bold text-indigo-600 dark:text-indigo-400">Sagar Athinarapu</h3>
            <p className="mt-2 text-gray-600 dark:text-gray-400">Sr.Software Engineer</p>
          </div>
          
          <div className="flex space-x-6">
            <p rel="noopener noreferrer" className="text-gray-600 hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400 transition-colors">
              <FiGithub className="text-2xl" />
            </p>
            <p rel="noopener noreferrer" className="text-gray-600 hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400 transition-colors">
              <FiLinkedin className="text-2xl" />
            </p>
            <p rel="noopener noreferrer" className="text-gray-600 hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400 transition-colors">
              <FiTwitter className="text-2xl" />
            </p>
            <a href="https://mail.google.com/mail/" className="text-gray-600 hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400 transition-colors">
              <FiMail className="text-2xl" />
            </a>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-200 dark:border-gray-700 text-center text-gray-500 dark:text-gray-400">
          <p>© {new Date().getFullYear()} Sagar Athinarapu. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;